import React from 'react';
import { DynamicDropdownTemplate } from 'themes/components';

function DynamicDropdown(props) {
    return <DynamicDropdownTemplate {...props}/>
}

export default DynamicDropdown;